import request from '@/utils/request'

// 查询企业微信员工列表
export function listEmployee(query) {
    return request({
        url: '/wxCp/employee/list',
        method: 'get',
        params: query
    })
}

// 查询企业微信员工详细
export function getEmployee(userid) {
    return request({
        url: '/wxCp/employee/' + userid,
        method: 'get'
    })
}

// 新增企业微信员工
export function addEmployee(data) {
    return request({
        url: '/wxCp/employee',
        method: 'post',
        data: data
    })
}
// 新增企业微信员工
export function RefreshCP_EmployeeList(data) {
    return request({
        url: '/wxCp/employee/RefreshCP_EmployeeList',
        method: 'post',
        data: data
    })
}
// 修改企业微信员工
export function updateEmployee(data) {
    return request({
        url: '/wxCp/employee/update',
        method: 'post',
        data: data
    })
}

// 删除企业微信员工
export function delEmployee(userid) {
    return request({
        url: '/wxCp/employee/delete/' + userid,
        method: 'post'
    })
}
export function updateEmployeeSetWelcome(userid) {
    return request({
        url: '/wxCp/employee/updateEmployeeSetWelcome/' + userid,
        method: 'get'
    })
}
export function updateEmployeeUnSetWelcome(userid) {
    return request({
        url: '/wxCp/employee/updateEmployeeUnSetWelcome/' + userid,
        method: 'get'
    })
}

